import Typography from '@mui/material/Typography';
import { GradientTypography } from 'src/components/gradients/GradientTypography';

export interface MintDetailProps {
  detailTitle: string;
  detailContent: string;
}

export function MintDetail({ detailContent, detailTitle }: MintDetailProps) {
  return (
    <>
      <GradientTypography variant="h5" gradientColor="primary.vertical">
        {detailTitle}
      </GradientTypography>
      <Typography variant="body1">{detailContent}</Typography>
    </>
  );
}
